import {Component, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {ApprovalPending} from '../shared/dto/approval-pending';
import {MatTableDataSource} from '@angular/material/table';
import {TokenStorageService} from '../shared/service/token-storage.service';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {ActivatedRoute} from '@angular/router';
import {BlacklistService} from '../shared/service/blacklist.service';
import swal from "sweetalert2";

@Component({
  selector: 'app-blacklist-process',
  templateUrl: './blacklist-process.component.html',
  styleUrls: ['./blacklist-process.component.scss']
})
export class BlacklistProcessComponent implements OnInit {
  public userName: string;
  public type: string;
  public types: string;
  blacklistForm: FormGroup;
  blacklist: boolean;
  suspend: boolean;
  public approvalPendingList: ApprovalPending[];
  approvalPending: ApprovalPending = new ApprovalPending();
  displayedColumns: string[] = ['refNo', 'nic', 'name', 'cdc' ,'stage', 'createdDate', 'action'];
  dataSource: MatTableDataSource<any>;
  public userroleCode:string;
  isTableLoading = true;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(private route: ActivatedRoute, private blackListService: BlacklistService,
              private tokenStorageService: TokenStorageService) {
    this.route.paramMap.subscribe(params => {
      this.type = params.get('type');
    });

    this.userName=this.tokenStorageService.getUserObjectToken().username;
    this.userroleCode=this.tokenStorageService.getUserObjectToken().userroleCode;

  }

  ngOnInit() {
    this.blacklistForm = new FormGroup({
      appRefNo: new FormControl(null),
      name: new FormControl(null),
      nic: new FormControl(null),
      cdcNo: new FormControl(null),
      new: new FormControl('new'),
    });
    this.blacklists();

  }

  setBase64(code: string): string {
    return btoa(code);
  }

  getAllRequestDetails(){
    this.approvalPending.appRefNo = this.blacklistForm.value.appRefNo;
    this.approvalPending.cdcNo = this.blacklistForm.value.cdcNo;
    this.approvalPending.name = this.blacklistForm.value.name;
    this.approvalPending.nic = this.blacklistForm.value.nic;
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = this.type;
    this.blackListService.searchRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.approvalPendingList = result;
        this.dataSource = new MatTableDataSource(this.approvalPendingList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.isTableLoading = false;
      }
    )
  }

  getAllSuspendedDetails() {
    this.blackListService.getDGSuspendedRequests().subscribe(
      (result: ApprovalPending[]) => {
        this.approvalPendingList  = result;
        this.dataSource = new MatTableDataSource(this.approvalPendingList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    )
  }

  onSearch() {
    if(this.blacklistForm.value.new === null ) {
      swal.fire('Error', 'Please select one category', 'error');

    }else if(this.blacklistForm.value.new === "new") {
      this.approvalPending.appRefNo = this.blacklistForm.value.appRefNo;
      this.approvalPending.cdcNo = this.blacklistForm.value.cdcNo;
      this.approvalPending.name = this.blacklistForm.value.name;
      this.approvalPending.nic = this.blacklistForm.value.nic;
      this.approvalPending.loginUser = this.userName;
      this.approvalPending.type = this.type;

      this.blackListService.searchRequestData(this.approvalPending).subscribe(
        (result: any ) => {
          this.approvalPendingList = result;
          this.dataSource = new MatTableDataSource(this.approvalPendingList);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      );
    }else if(this.blacklistForm.value.new === "suspend"){
      this.approvalPending.appRefNo = this.blacklistForm.value.appRefNo;
      this.approvalPending.cdcNo = this.blacklistForm.value.cdcNo;
      this.approvalPending.name = this.blacklistForm.value.name;
      this.approvalPending.nic = this.blacklistForm.value.nic;
      this.approvalPending.loginUser = this.userName;
      this.approvalPending.type = this.type;

      this.blackListService.searchSuspendedRequestData(this.approvalPending).subscribe(
        (result: any ) => {
          this.approvalPendingList = result;
          this.dataSource = new MatTableDataSource(this.approvalPendingList);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      );
    }
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onReset() {
    this.blacklistForm.reset({
      sidNo: null,
      name: null,
      nicNo: null,
      cdcNo: null,
    });
    this.getAllRequestDetails();
  }

  blacklists(){
    this.types = "blacklist";
    this.getAllRequestDetails()
  }

  suspends() {
    this.types = "suspend";
    this.getAllSuspendedDetails();
  }

}
